export const EmptyAuditState = () => (
  <div className='audit-empty'>
    <div className='audit-empty__title'>No audit selected</div>
    <div className='audit-empty__hint'>
      Start a new audit from the sidebar, or pick one from history.
    </div>
  </div>
);
